import { mapGetters } from 'vuex'
import _ from 'lodash'
import { loadMicroApp, initGlobalState, runAfterFirstMounted } from 'qiankun/dist/index.umd'
import { STORE_AUTHORIZATION_NO_DISPLAY } from '@/store/mutation-types'
import store from '@/store'
import { getLodop } from '@/utils/lodopFuncs.js'
import WS from './microApps.config.ws'
import qs from 'qs'
import { i18nRender as $t } from '@/locales'

const microApps = [
  {
    // entry: 'http://localhost:9000',
    entry: (process.env.VUE_APP_SSOWEB_ENTRY + (process.env.SSO_ENV ? '/' + process.env.SSO_ENV + '/' : '')),
    name: 'sso-web',
    systemCode: 'SSO_SYS_USER'
  },
  {
    // entry: process.env.VUE_APP_UNIVERSAL_ENTRY,
    entry: process.env.VUE_APP_UNIVERSAL_ENTRY,
    name: 'universal_system',
    systemCode: 'UNIVERSAL_SYSTEM'
  }
]

const defaultMircoApp = 'sso-web'
const startMonitor = () => {
  !/proxy/.test(window.location.hostname) && createScript(process.env.VUE_APP_CNZZ)
}

const createScript = (url) => {
  let scriptElement = document.createElement('script')
  document.body.appendChild(scriptElement)
  scriptElement.src = url
}

// 第一个微应用 mount 后需要调用的方法，比如开启一些监控或者埋点脚
runAfterFirstMounted(() => startMonitor())

const microAppsMixin = {
  mixins: [WS],
  data () {
    return {
      loadedMicroApps: {},
      microAppStateActions: null,
      messageFlag: false,
      timre: null,
      count: 3
    }
  },
  computed: {
    ...mapGetters([
      'microApps',
      'currentLang',
      'isDemo',
      'activeKey',
      'menus',
      'notification',
      'userInfo',
      'userConfig',
      'messageClassification',
      'systems',
      'panes',
      'iframes'
    ])
  },
  methods: {
    loadMicroApp (appName) {
      if (!appName) return

      const that = this
      const { microApps, loadedMicroApps, menus } = this
      const { path, params: { serviceId, systemCode } } = this.$route
      const cacheKey = path.startsWith('/entry') ? `${serviceId}-${systemCode}-${appName}` : appName
      const appConfig = appName && microApps.find(app => app.name === appName)
      const appProps = {
        window,
        logout () {
          that.$store.dispatch('Logout')
        },
        /**
         * @description 通知提示框
         * @param {object} data - { type: 'success', message: '通知标题', description: '通知内容' }
         * @param {string} data.type - 类型 [success|error|info|warning|warn]
         * @param {string} data.message - 通知提醒标题，必选
         * @param {string} data.description - 通知提醒内容，必选
         * @param ... - 更多查阅https://antdv.com/components/notification-cn/
         */
        notification (data) {
          that.$notification(data)
        },
        globalErrorHandler (data) {
          const params = Object.assign({
            errorCode: 404,
            pageUrl: '-',
            systemCode: appConfig?.systemCode
          }, data)

          that.$store.dispatch('DingTalkNotice', params)
        },
        globalAuthSuccess (data) {
          this.$ls.set(STORE_AUTHORIZATION_NO_DISPLAY, true)
        },
        isDemo: that.isDemo,
        lang: that.currentLang,
        microApps: _.cloneDeep(microApps),
        menus: _.cloneDeep(menus),
        showYST: this.$showYST,
        open: this.$winOpen // 改写window.open (* 支持灰度等）
      }

      // for (let key of Object.keys(loadedMicroApps)) {
      //   if (key !== cacheKey && /sso-web/.test(key)) {
      //     loadedMicroApps[key].unmount()
      //     delete loadedMicroApps[key]
      //   }
      // }

      if (path.startsWith('/entry')) {
        Object.assign(appProps, {
          navigator: {
            /**
             * @description 打开新标签
             * @param {object} data - { key: 'new', tab: '新增窗口', path: 'about:blank', closable: true }
             * @param {string} data.key - 唯一标识
             * @param {string} data.tab - 标签标题
             * @param {string} data.path - 标签路径
             * @param {boolean} data.closable - 是否可关闭，默认true
             */
            push (data) {
              if (!data.systemCode) {
                that.$message.error('系统代码不能为空')
                return
              }

              function noPermission () {
                this.$warning({
                  prefixCls: 'home-ant-modal',
                  title: $t('notification-modal.title.prompt'),
                  content: $t('layout.error-401'),
                  okText: $t('station.我知道了'),
                  okButtonProps: {
                    props: {
                      prefixCls: `home-ant-btn`
                    }
                  },
                  cancelButtonProps: {
                    props: {
                      prefixCls: `home-ant-btn`
                    }
                  }
                })
              }

              const systemName = microApps.find(item => item.systemCode === data.systemCode)?.name

              if (!systemName) {
                return noPermission()
              }

              if (data.menuUrl) {
                // 跳转菜单内的页面
                that.$store.dispatch('entry/findPane', { menuUrl: data.menuUrl, systemCode: data.systemCode })
                  .then((pane) => {
                    const newPane = _.cloneDeep(pane)

                    if (data.path) {
                      newPane.path = `/entry/${serviceId}/${systemCode}/${systemName}#${data.path}`
                    }

                    if (data.query) {
                      newPane.path = `${newPane.path}?${qs.stringify(data.query)}`
                    }

                    that.$store.dispatch('entry/SetActiveAsync', newPane)
                  })
                  .catch(noPermission)
              } else if (data.path) {
                const pane = {
                  key: `${systemName}#${data.path}`,
                  systemCode: data.systemCode,
                  menuName: data.menuName || '新增窗口',
                  menuUrl: data.menuUrl || data.path,
                  path: `/entry/${serviceId}/${systemCode}/${systemName}#${data.path}`,
                  external: false,
                  ignore: true,
                  noCache: data.noCache === undefined ? true : data.noCache,
                  closable: data.closable === undefined ? true : data.closable
                }

                if (data.query) {
                  pane.path = `${pane.path}?${qs.stringify(data.query)}`
                  pane.key = `${systemName}#${data.path}?${qs.stringify(data.query)}`
                }

                const panes = that.$store.getters.panes
                const isExit = panes.find((item) => item.systemCode === pane.systemCode && item.path === pane.path)

                console.log('isExit', systemName, isExit)

                if (isExit) {
                  that.$store.commit('entry/SET_ACTIVE_KEY2', isExit.key)
                  that.$router.push(isExit.path)
                } else {
                  that.$store.dispatch('entry/Navigator', pane)
                }
              } else {
                this.$message.error('跳转地址不能为空')
              }
            },
            /**
             * @param {object} data = { path: '/user/home', systemCode: 'SSO_SYS_USER', tab: '用户中心', menuName: { zh_CN: '用户中心', en_US: 'User Center' } }
             * @param {string} data.path - 跳转地址
             * @param {string} data.systemCode - 系统代码
             * @param {string} data.tab - 默认菜单名称（未匹配菜单名使用）
             * @param {object} data.menuName
             * @param {string} data.menuName.zh_CN
             * @param {string} data.menuName.en_US
             */
            pushByPath (data, done = () => {}) {
              const systemName = microApps.find(item => item.systemCode === data.systemCode)?.name
              const pane = {
                ...data,
                key: `${systemName}#${data.path}`,
                systemName,
                path: `/entry/${serviceId}/${systemCode}/${systemName}#${data.path || 'm_' + data.key}`
              }
              that.$store.dispatch('entry/SetActiveAsync', pane)
                .then(success => done(success))
            },
            /**
             * @description 打开新页签（async）! 以下没有默认值的需任选一项或多项填写
             *
             * @update1 填写external可在iframe打开外链并创建新页签
             * @update2 填写ignore可绕过菜单权限 * 需指定 systemCode path
             * @update2 不填写key将使用path做为key
             *
             * @param {object=*}  data - { next, verify, systemCode, path, routerMethods, ... }
             * @param {string} data.path - 跳转地址
             * @param {boolean=false} data.ignore - 忽略（绕过）菜单权限
             * @param {string} data.systemCode - 子系统代码 (不传默认iframe打开)
             * @param {string} data.key - tab下标 （* 唯一值）
             * @param {string} data.functionClass - 权限标识符
             * @param {object} data.menuName - tab页签名称 { zh_CN: 'xxx', en_US: 'xxx_en', ko_KR: 'xxx_ko' }
             * @param {boolean=false} data.external - 打开外部地址 (仅限iframe打开)
             * @param {string} data.menuUrl - iframe.src (data.external为真有效)
             * @param {object} data.menuParams - iframe.src += &menuParams (data.externagil为真有效) { xx: 'xxx', xx: 'xxx' }
             * @param {boolean=false} data.replace - 打开新页面并替换当前tab页签
             * @param {boolean|string=warning} data.verify - 抛出Promise.reject (等于warning抛出错误提示)
             * @param {boolean=true} data.next - 是否由乾坤底座执行路由跳转 （配置为false可在done回调中TODO）
             * @param {string =push}  data.routerMethods - 路由跳转方式 push | replace | go | back | forward
             * @param {function} done callback 菜单鉴权成功回调
             * @param {function} fail callback 菜单鉴权失败回调（无权限|找不到菜单|菜单过期）
             */
            pushByAsync (data, done = () => { }, fail = () => { }) {
              if (data.external && data.systemCode) {
                const systemDomain = microApps.find(item => item.systemCode === data.systemCode)?.entry || null
                if (systemDomain && !/^http/.test(data.menuUrl)) {
                  data.menuUrl = `${systemDomain.replace(/\/$/, '')}${data.menuUrl}`
                }
                data.systemCode = undefined
              }
              const systemName = microApps.find(item => item.systemCode === data.systemCode)?.name || 'iframe'
              const pane = {
                ...data,
                systemName
              }
              if (data.path || data.key) {
                pane.path = `/entry/${serviceId}/${systemCode}/${systemName}#${data.path || '/m_' + data.key}`
              }
              that.$store.dispatch('entry/SetActiveAsync', pane)
                .then(success => done(success))
                .catch(error => fail(error))
            },
            /**
             * @description 关闭标签
             * @param {object} data - { key: 'new' }
             * @param {string} data.key - 关闭标签的key值
             * @param {object} data.pane - 关闭后新开的标签
             */
            /**
             * @description 关闭指定标签
             * @param {object} data - { key: 'new' }
             * @param {string} data.key - 关闭标签的key值
             * @param {object} data.pane - 关闭后新开的标签
             */
            async close ({ key: closeKey, pane }) {
              const systemName = pane.systemCode ? microApps.find(item => item.systemCode === pane.systemCode)?.name : undefined
              const activeKey = closeKey || that.$store.getters.activeKey
              const homeMenuId = that.$store.state.entry.homeMenuId
              const goHome = () => {
                that.$store.commit('entry/SET_ACTIVE_KEY', { key: homeMenuId })
              }

              if (pane && !systemName) {
                this.$warning({
                  prefixCls: 'home-ant-modal',
                  title: $t('notification-modal.title.prompt'),
                  content: $t('layout.error-401'),
                  okText: $t('station.我知道了'),
                  okButtonProps: {
                    props: {
                      prefixCls: `home-ant-btn`
                    }
                  },
                  cancelButtonProps: {
                    props: {
                      prefixCls: `home-ant-btn`
                    }
                  }
                })
                return
              }

              const { key } = await that.$store.dispatch('entry/ClosePane', activeKey)

              if (pane?.menuUrl && pane?.systemCode) {
                // 跳转菜单内的页面
                that.$store.dispatch('entry/findPane', { menuUrl: pane.menuUrl, systemCode: pane.systemCode })
                  .then((newPane) => {
                    that.$store.dispatch('entry/SetActiveAsync', newPane)
                  })
                  .catch(goHome)
              } else if (pane?.path && pane?.systemCode) {
                const menuUrl = `${systemName}#${pane.path}`
                let path = `/entry/${serviceId}/${systemCode}/${menuUrl}`

                if (pane?.query) {
                  const query = qs.stringify(pane.query)
                  path = `${path}?${query}`
                }

                const isExit = that.$store.getters.panes.find((item) => item.systemCode === pane.systemCode && item.path === path)

                if (isExit) {
                  that.$store.commit('entry/SET_ACTIVE_KEY2', isExit.key)
                  that.$router.push(isExit.path)
                } else {
                  that.$store.dispatch('entry/Navigator', {
                    key: pane.key || menuUrl,
                    systemCode: pane.systemCode,
                    menuName: pane.menuName,
                    menuUrl: pane.path,
                    path,
                    external: false,
                    ignore: true,
                    noCache: pane.noCache === undefined ? true : pane.noCache,
                    closable: pane.closable === undefined ? true : pane.closable
                  }).catch(goHome)
                }
              } else {
                that.$store.commit('entry/SET_ACTIVE_KEY2', key)
              }
            },
            // 打印服务（Lodop）
            getLodop () {
              return getLodop()
            }
          },
          modifyPanePath (path) {
            that.$store.dispatch('entry/modifyPanePath', path)
          }
        })
      }

      let configuration = {
        sandbox: true
      }

      if (!loadedMicroApps[cacheKey] && appConfig) {
        loadedMicroApps[cacheKey] = loadMicroApp({
          container: `#${cacheKey}-view-box`,
          props: appProps,
          ...appConfig
        }, configuration)
      } else {
        loadedMicroApps[cacheKey]?.update && loadedMicroApps[cacheKey]?.update()
      }
      // console.log('loadedMicroApps', loadedMicroApps)
    },
    mountMircoApp (cacheKey) {
      this.loadedMicroApps[cacheKey]?.mount()
    },
    unmountMircoApp (cacheKey) {
      if (this.loadedMicroApps[cacheKey]?.getStatus() === 'MOUNTED') {
        this.loadedMicroApps[cacheKey].unmount()
      }
    },
    refreshMircoApps () {
      for (let i of Object.keys(this.loadedMicroApps)) {
        const appName = i.replace(/(.*?-){2}/g, '')
        this.unmountMircoApp(i)
        delete this.loadedMicroApps[i]
        setTimeout(() => this.loadMicroApp(appName), 300)
      }
    },
    packageName () {
      const { systemCode } = this.$route.params
      const { microApps } = this.$store.getters
      const currentApp = systemCode === 'ERP'
        ? microApps.find(item => item.systemCode === 'ORDER_MANAGER')
        : microApps.find(item => item.systemCode === systemCode)

      return currentApp?.packageName || '-'
    }
  },
  async mounted () {
    const { currentLang, messageClassification, userInfo, userConfig, notification, systems, panes } = this
    this.microAppStateActions = initGlobalState({
      userInfo: userInfo || {},
      userConfig: { ...userConfig, packageName: this.packageName() } || {},
      systems: systems || [],
      lang: currentLang,
      notification: notification,
      messageFlag: false, // 控制是否弹出右下角提醒 (true 不弹)
      messageClassification,
      activeEnv: process.env.SSO_ENV || '',
      activePane: {},
      panes
    })
    this.microAppStateActions.onGlobalStateChange((state, prev) => {
      if (state.notification === 'change') {
        store.dispatch('queryMsgNoticePage')
      }
      if (state.userInfo === 'change') {
        store.dispatch('GetUserInfo', { reset: true })
      }
      if (state.userConfig === 'change') {
        store.dispatch('GetUserConfig', true)
      }
      if (state.systems === 'change') {
        store.dispatch('QuerySystemExtListForSub', true)
      }
      this.messageFlag = state.messageFlag
    })
    // 本地缓存是否显示一键建站的new图标显示
    const siteKey = 'sso_user_info_buildStationStatus'
    if (userInfo.buildStationStatus === 2 && !sessionStorage.getItem(siteKey)) {
      sessionStorage.setItem(siteKey, userInfo.buildStationStatus)
    }
    const watchs = [
      'notification',
      'userInfo',
      'userConfig',
      'systems',
      'messageClassification',
      'panes'
    ]
    const watchsByVar = [
      ['currentLang', 'lang'],
      ['activeKey', 'activePane', (value) => [...this.panes, ...this.iframes].find(f => f.key === value)]
    ]
    for (let key of [...watchs, ...watchsByVar]) {
      const isArray = Array.isArray(key)
      this.$watch(isArray ? key[0] : key, (value) => {
        if (isArray) {
          this.microAppStateActions.setGlobalState({
            [key[1]]: key[2] ? key[2](value) : value
          })
        } else {
          this.microAppStateActions.setGlobalState({
            [key]: value
          })
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.timre)
  }
}

export default microApps
export { defaultMircoApp, microAppsMixin }
